var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo",style:(Object.assign({}, _vm.customStyle(),
    {backgroundImage: _vm.generateBackgroundImage(),
    backgroundColor: _vm.generateBackgroundColor()}))},[(_vm.user.name && !this.generateBackgroundImage())?_c('div',{staticClass:"name"},[_vm._v(" "+_vm._s(_vm.user.name.charAt(0))+" ")]):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }